import React, {useContext} from "react";
import {DynamicComponent, DynamicComponentProps} from "../../core/_models";
import {Tab, Tabs} from "react-bootstrap";
import {drawDynamicComponent} from "../_drawDynamicComponent";

export function DynamicTabsComponent({config: {children, value, id, action}, context}: DynamicComponentProps) {
    const formContext = useContext(context);

    return (
        <Tabs
            id={id}
            activeKey={value}
            onSelect={(key) => {
                if (action != null) {
                    const values: { [key: string]: any } = {};
                    values[id] = key;
                    formContext.submit({action, values})
                }
            }}
        >
            {(children as DynamicComponent[]).map(
                child =>
                    <Tab
                        eventKey={child.id}
                        title={child.caption || 'Tab'}
                    >
                        <div className='pt-6'>
                            {drawDynamicComponent(child, context)}
                        </div>
                    </Tab>
            )}
        </Tabs>
    )
}